import React from 'react';
import update from 'react-addons-update';
import Submenu from './Submenu';

// import MapLink from '../MapLink';

class LocationMenu extends Submenu {

  // static propTypes = {
  //   locations: React.PropTypes.object.isRequired
  // }

  constructor(props) {
    super(props);
    this.locations = props.locations;
    this.analytics = this.props.analytics;
    this.state = {
      original_tree: this.locations,
      child_keys: this.getRegions(this.locations),
      region_tree: this.locations,
      parent_tree: false,
      parent_key: false,
      trackingData: {
        region: '',
        subRegion: '',
        regionId: '',
        subRegionId: '',
      },
    };
  }

  getRegions(tree) {
    if (tree) {
      const regions = Object.keys(tree);
      return regions;
    }
  }

  // return the first node that has `slug` as a key
  getParent(node, slug) {
    if (node.children || node.hasOwnProperty('id')) {
      const theKeys = node.hasOwnProperty('id') ? Object.keys(node) : Object.keys(node.children);
      if (theKeys.indexOf(slug) > -1) {
        return node;
      }
      let result;
      for (let i = 0; result == null && i < theKeys.length; i++) { result = this.getParent(node[theKeys[i]], slug); }
      return result;
    }
    return null;
  }

  getRegion(node, slug) {
    if (!node) return null;
    if (node.slug || node.hasOwnProperty('id')) {
      const theKeys = node.hasOwnProperty('id') ? Object.keys(node) : Object.keys(node.children);
      if (node.slug === slug) {
        return node;
      }
      let result;
      for (let i = 0; result == null && i < theKeys.length; i++) { result = this.getRegion(node[theKeys[i]], slug); }
      return result;
    }
    return null;
  }

  setRegion(region) {
    if (region.hasOwnProperty('id')) { // this is the root of the tree
      this.setState(update(this.state,
        { $set: {
          original_tree: region,
          child_keys: this.getRegions(region),
          region_tree: region,
          parent_tree: false,
          parent_key: false,
        } },
      ));
    } else if (!region.slug) { // move up the tree
      const tree = this.getRegion(this.state.original_tree, this.state.parent_key);
      const parentTree = this.getParent(this.state.original_tree, tree.slug);
      this.setState(update(this.state,
        { $set: {
          child_keys: this.getRegions(tree.children),
          region_tree: tree.children,
          parent_tree: parentTree,
          parent_key: parentTree.slug || false,
          region_key: tree.slug,
          trackingData: { // clear the subregion when moving up the tree
            ...this.state.trackingData,
            subRegion: '',
            subRegionId: '',
          },
        } },
      ));
    } else { // move down the tree
      const tree = region.children;

      let trackingData = {};

      if (!this.state.parent_tree) { // region
        trackingData = {
          ...this.state.trackingData,
          region: region.name,
          regionId: region.slug,
        };
      } else { // subregion
        trackingData = {
          ...this.state.trackingData,
          subRegion: region.name,
          subRegionId: region.slug,
        };
      }

      this.setState(update(this.state,
        { $set: {
          child_keys: this.getRegions(tree),
          region_tree: tree,
          parent_tree: this.state.region_tree,
          parent_key: this.state.region_key,
          region_key: region.slug,
          trackingData,
        } },
      ));
    }
  }

  hasChildren(region) {
    return !!((region && region.children));
  }

  gotoMap(node) {
    if (window) {
      this.props.doTrackEvent('Location Clicked', {
        locationName: node.name,
        locationId: node.slug,
        subregionName: this.state.trackingData.subRegion,
        subregionId: this.state.trackingData.subRegionId,
        regionName: this.state.trackingData.region,
        regionId: this.state.trackingData.regionId,
      });

      window.location.assign(`/map/${node.slug}`);
    }
  }


  render() {
    const navClasses = super.getMenuClasses('locationMenu');
    return (
      <ul id="locationMenu" className={navClasses}>
        {!this.state.parent_tree && <li className="header">Make a selection...</li>}
        {(() => {
          if (this.state.parent_tree) {
            return (
              <li
                className="default parent"
                onClick={this.setRegion.bind(this, this.state.parent_tree)}
              >
                <a href="#">
                  <i className="fa fa-angle-left" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.parent_tree[this.state.region_key].name}
                </a>
              </li>
            );
          }
        })()}

        {
          this.state.child_keys.map((region) => {
            const node = this.state.region_tree[region];
            if (this.hasChildren(node)) {
              return (
                <li
                  className="default"
                  onClick={this.setRegion.bind(this, node)}
                >
                  <a href="#">
                    {node.name} <i className="fa fa-angle-right" />
                  </a>
                </li>
              );
            } else if (node && node.location) {
              return (
                <li
                  className="default"
                  onClick={this.gotoMap.bind(this, node)}
                >
                  <a href="#">
                    {node.name}
                  </a>
                </li>
              );
            }
          })
        }
      </ul>
    );
  }

}

export default LocationMenu;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/menus/MobileLocationMenu.js